import { render, staticRenderFns } from "./addClassify.vue?vue&type=template&id=e66dc41c&scoped=true"
import script from "./addClassify.vue?vue&type=script&lang=js"
export * from "./addClassify.vue?vue&type=script&lang=js"
import style0 from "./addClassify.vue?vue&type=style&index=0&id=e66dc41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66dc41c",
  null
  
)

export default component.exports